import {CurrencyPipe, DatePipe, NgTemplateOutlet} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatNoDataRow,
    MatRow,
    MatRowDef,
    MatTable
} from '@angular/material/table';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {PaymentTransactionModel} from '../../../models/contract.model';
import {FinanceWalletModel} from '../../../models/finance.model';
import {MemberModel} from '../../../models/user.model';
import {FinanceService} from '../../../services/api/finance.service';
import {AlertService} from '../../../services/notify/alert.service';
import {buildItemsMap} from '../../calendar/calendar-utils';
import {CalendarItem, CalendarLegend} from '../../calendar/calendar.model';
import {ComponentsModule} from '../../components.module';

@Component({
    selector: 'app-finance-index-tab',
    standalone: true,
    imports: [
        CurrencyPipe,
        DatePipe,
        MatCell,
        MatCellDef,
        MatColumnDef,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatRow,
        MatRowDef,
        MatTable,
        NgTemplateOutlet,
        ComponentsModule,
        MatHeaderCellDef,
        MatNoDataRow,
        TranslatePipe,
    ],
    templateUrl: './finance-index-tab.component.html',
    styleUrl: './finance-index-tab.component.scss'
})
export class FinanceIndexTabComponent implements OnInit {
    @Input() currentMember: MemberModel;

    tab = 0;


    mainFinanceStatistic: {
        total: number;
        out: number;
        in: number;
    };

    allWallets: {
        currentTab: string;
        allSingleContractWallets: FinanceWalletModel[],
        allMultiplyContractWallets: FinanceWalletModel[],
        allWalletsWithoutContracts: FinanceWalletModel[],
    };

    allPayments: {
        currentTab: string;
        allPayments: PaymentTransactionModel[],
        incomingPayments: PaymentTransactionModel[],
        outcomingPayments: PaymentTransactionModel[],
    };

    current = new Date();
    itemsMap: Record<string, CalendarItem[]> = {};

    calendarLegend: CalendarLegend[];

    constructor(
        private financeService: FinanceService,
        private alert: AlertService,
        private translate: TranslateService,
    ) {
        this.calendarLegend = [
            {
                type: 'light',
                title: this.translate.instant('INDEX_PAGE.FINANCE.TEXT.LEGEND.WAIT')
            },
            {
                type: 'blue',
                title: this.translate.instant('INDEX_PAGE.FINANCE.TEXT.LEGEND.OUTCOMING')
            },
            {
                type: 'green',
                title: this.translate.instant('INDEX_PAGE.FINANCE.TEXT.LEGEND.INCOMING')
            }
        ];
    }

    ngOnInit() {
        this.getMainFinanceStatistic();
        this.getAllProjectWallets();
        // this.getAllPaymentsHistory();
    }

    getMainFinanceStatistic(): void {
        this.financeService.getMoneyInfo().subscribe({
            next: res => {
                this.mainFinanceStatistic = {
                    total: parseInt(res.forecast.forecast_total.total, 10),
                    in: parseInt(res.forecast.forecast_total.incoming_approved_total, 10),
                    out: parseInt(res.forecast.forecast_total.outcoming_approved_total, 10)
                };
            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
            }
        });
    }

    getAllProjectWallets(): void {
        this.financeService.getFinance().subscribe({
            next: res => {
                this.allWallets = {
                    currentTab: 'allSingleContractWallets',
                    allSingleContractWallets: res.purse.wallets.filter(x => x.contracts.length === 1),
                    allMultiplyContractWallets: res.purse.wallets.filter(x => x.contracts.length > 1),
                    allWalletsWithoutContracts: res.purse.wallets.filter(x => !x.contracts.length),
                };

            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
            }
        });
    }

    //TODO будут курсы валют

    getAllPaymentsHistory(): void {
        this.financeService.getPaymentsHistory().subscribe({
            next: res => {
                this.allPayments = {
                    currentTab: 'allPayments',
                    allPayments: res.payments?.data,
                    incomingPayments: res.payments?.data?.filter(x => x.recipient &&
                        x.recipient.guid === this.currentMember.project_setting.project.guid),
                    outcomingPayments: res.payments?.data?.filter(x => x.payer &&
                        x.payer.guid === this.currentMember.project_setting.project.guid),
                };
            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
            }
        });
    }

    //TODO будет календарь

    getPaymentsForCalendar(startDate: Date, endDate: Date): void {
        console.log(startDate.toUTCString(), endDate.toString());

        this.financeService.getPaymentsBetweenDates(startDate.toUTCString(), endDate.toUTCString()).subscribe({
            next: res => {
                console.log(res);

                this.allPayments = {
                    currentTab: 'allPayments',
                    allPayments: res.payments?.data,
                    incomingPayments: res.payments?.data?.filter(x => x.recipient &&
                        x.recipient.guid === this.currentMember.project_setting.project.guid),
                    outcomingPayments: res.payments?.data?.filter(x => x.payer &&
                        x.payer.guid === this.currentMember.project_setting.project.guid),
                };

                this.onAddItems(startDate, endDate);
            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
            }
        });
    }

    onDayClick(date: Date) {
        console.log('day clicked', date);
    }

    onItemClick(payload: { date: Date; item: CalendarItem }) {
        console.log('item clicked', payload);
    }

    onAddItems(startDate: Date, endDate: Date): void {
        const payments = this.allPayments.allPayments;

        const filtered: (CalendarItem & { __key: string })[] = [];

        for (const payment of payments) {
            const status = payment.payment_status;

            if (!(
                status === 'NEW' ||
                status === 'APPROVED' ||
                status === 'EXECUTION' ||
                status === 'SUCCESS' ||
                status === 'PROMISED'
            )) {
                continue;
            }

            const creationDate = new Date(new Date(payment.created_at).toDateString());
            if (creationDate < startDate || creationDate > endDate) {
                continue;
            }

            // Определяем тип транзакции
            let transactionType: 'light' | 'blue' | 'green';
            if (payment.payer_guid &&
                this.currentMember.project_setting.project.guid === payment.payer_guid) {
                transactionType = 'light';
            } else if (payment.recipient_guid &&
                this.currentMember.project_setting.project.guid === payment.recipient.guid) {
                transactionType = 'blue';
            } else {
                transactionType = 'green';
            }

            const y = creationDate.getFullYear();
            const m = (creationDate.getMonth() + 1).toString().padStart(2, '0');
            const d = creationDate.getDate().toString().padStart(2, '0');
            const key = `${y}-${m}-${d}`;

            filtered.push({
                __key: key,
                id: payment.guid,
                title: status,
                value: payment.total.toString(),
                type: transactionType,
            } as any);
        }

        const newMap = buildItemsMap(filtered, this.itemsMap);

        if (newMap !== this.itemsMap) {
            this.itemsMap = newMap;
        }
    }

}
